/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Patient from "../Patient";
import { qreq } from "../../shared/qrequest";
import LoadingAlert from "../LoadingAlert";
import Alert from "../Alert";
import Card from "../Card";
import FormInput from "../FormInput";
import SignatureCanvas from "react-signature-canvas";
import Icon from "../Icon";
import React from "react";
import { Modal } from "react-bootstrap";

class RequestFormFill extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            sigPos: {}
        };
        this.sigCanvasRef = [];
        this.sigWrapperRef = React.createRef();
        this.submit = this.submit.bind(this);
        this.formatForm = this.formatForm.bind(this);
        this.positionSignature = this.positionSignature.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/form/get/' + this.props.params.uniqueIdent + '/public', j => {
            if (j.item) {
                this.setState({ item: j.item });
                qreq.get('/api/form/type/' + j.item.requestFormTypeID, j => {
                    if (j.item) {
                        this.setState({ form: j.item });
                        this.formatForm(j.item);
                    }
                    else
                        this.setState({ error: j.errorMessage });
                }, () => {
                    this.setState({ error: 'Unknown error. Please close this page and click the link again.' });
                });
            }
            else
                this.setState({ error: j.errorMessage });
        }, () => {
            this.setState({ error: 'Unknown error. Please close this page and click the link again.' });
        });
    }

    formatForm(form) {
        form.formFields.filter(a => a.fieldType === 'Signature').forEach(i => {
            this.sigCanvasRef[i.fieldIdent] = React.createRef();
        });


        var matches = form.content.matchAll(/<input([^>]+)>/g);
        matches = Array.from(matches);
        matches.forEach(m => {
            var info = {};
            var fieldMatches = m[1].matchAll(/([^=]+)="([^"]+)"/g);
            fieldMatches = Array.from(fieldMatches);
            fieldMatches.forEach(i => {
                i[1] = i[1].trim();
                i[2] = i[2].trim();
                if (i[1] === "data-type")
                    info.fieldType = i[2];
                if (i[1] === "name")
                    info.fieldIdent = i[2];
                if (i[1] === "placeholder")
                    info.fieldName = i[2];
            });

            if (info.fieldIdent) {
                var fieldInfo = form.formFields.find(f => f.fieldIdent === info.fieldIdent);
                if (fieldInfo) {
                    if (fieldInfo.fieldType === 'Signature') {
                        form.content = form.content.replace(m[0], `<div id="f-sig-${info.fieldIdent}" class="f-sig" style="height: 300px; width: 500px;"></div>`);
                    }
                    else {
                        form.content = form.content.replace(m[0], `<div class="mb-3 p-1">
                        <label class="form-label" for="${fieldInfo.fieldIdent}">${fieldInfo.fieldName}</label>
                        <div class="input-group">
                            <input type="text" data-type="form-field" class="form-control form-control-lg" name="${fieldInfo.fieldIdent}" placeholder="${fieldInfo.fieldName}" value="" required="required" />
                    </div>
                    </div>`);
                    }
                }
            }
        });

        this.setState({ form: form });

        setTimeout(() => {
            this.positionSignature();
        }, 1000);
    }

    positionSignature() {
        var sigPos = { ...this.state.sigPos };
        var sigs = document.getElementsByClassName('f-sig');
        if (sigs) {
            sigs = Array.from(sigs);
            sigs.forEach(i => {
                var rect = i.getBoundingClientRect();
                var id = i.id.replace('f-sig-', '');
                sigPos[id] = { top: (rect.top + 50) + 'px', left: (rect.left + 50) + 'px' };
            });
        }

        this.setState({ sigPos: sigPos });
    }

    submit(e) {
        if (e) e.preventDefault();
        var info = { ...this.state.item, ...this.state.info };

        var stop = false;

        info.props = [];


        var sigs = this.state.form.formFields.filter(a => a.fieldType === 'Signature');


        sigs.forEach(i => {
            var id = i.fieldIdent;
            if (this.sigCanvasRef[id].current.isEmpty()) {
                this.alert('Please sign all signature fields before submitting.');
                stop = true;
                return;
            }
            var prop = { fieldIdent: id, fieldValue: this.sigCanvasRef[id].current.getTrimmedCanvas().toDataURL('image/png').split(',')[1] };
            info.props.push(prop);
        });

        if (stop) return;


        var fields = document.querySelectorAll('input[data-type="form-field"]');

        fields.forEach(f => {
            var prop = { fieldIdent: f.name, fieldValue: f.value };
            info.props.push(prop);
        });

        this.setState({ submitting: true });
        qreq.post('/api/form/fill', info, j => {
            if (j.errorCode === 0) {
                this.setState({ success: true });
            }
            else {
                this.setState({ submitting: false });
                this.alert(j.errorMessage);
            }
        }, () => {
            this.setState({ submitting: false });
            this.unkownErrorCallback();
        });
    }

    render() {
        if (this.state.error)
            return <div className="container-fluid"><h1><L>Error</L></h1><Alert type="warning">{this.state.error}</Alert></div>;
        if (!this.state.item)
            return <LoadingAlert />
        if (this.state.success) {
            return <div className="container-fluid">
                <h1><L>Success</L></h1>
                <Alert type="success"><L>Form signed successfully.</L></Alert>
                {this.props.inline ? <div className="d-grid"><button type="button" className="btn btn-primary btn-lg" onClick={() => { this.goBack(); this.goBack(); }}>Back to Record</button></div> : <p><L>You may now close this page.</L></p>}
            </div>;
        }

        return <div className="container">
            <h1>{this.state.form?.name}</h1>
            <form onSubmit={this.submit}>
                <div dangerouslySetInnerHTML={{ __html: this.state.form?.content }}></div>
                <div className="my-3 text-center">
                    <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}><Icon icon="faCaretRight" /> <L>Submit</L></button>
                </div>
            </form>
            {this.state.form?.formFields.filter(a => a.fieldType === 'Signature').map((i, idx) => <div key={idx} className={this.state.sigPos[i.fieldIdent] ? 'd-block position-absolute' : 'd-none'} style={{ top: this.state.sigPos[i.fieldIdent]?.top, left: this.state.sigPos[i.fieldIdent]?.left }}>
                <div className="d-grid align-items-center justify-content-center">
                    <button type="button" className="btn btn-secondary" onClick={() => this.sigCanvasRef[i.fieldIdent].current.clear()}>Reset Signature</button>
                    <SignatureCanvas ref={this.sigCanvasRef[i.fieldIdent]} canvasProps={{ width: 400, height: 200, className: 'border' }} />
                </div>
            </div>)}
            <div className="p-5"></div>
        </div>;
    }
}

export default withParamsAndNavigate(RequestFormFill);